import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy, ViewChildren, QueryList, ViewChild } from '@angular/core';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataService } from '../../utils/data.service';
import { MatSelectChange, MatDialog } from '@angular/material';
import { modalComponent } from '../../utils/modal/modal.component';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Documento } from '../../models/documento';
import { DocumentoDetalle } from '../../models/DocumentoDetalle';

import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { PagoVentaService } from '../../pago-venta/pago-venta.service';
import { DocumentAgregar } from '../../models/document-agregar';
import * as $ from 'jquery';
import { skip } from 'rxjs/operators';
import { Cliente } from '../../models/cliente';
import { MatSelect } from '@angular/material/select';
import { ProductAddEditComponent } from '../../product/add-edit/product-add-edit.component';
import { Item } from '../../models/item';
import { direccionAddEditComponent } from '../../cliente-sae/cliente-sae-agregar-editar/direcciones/direccionAddEdit.component';
import { ClienteSaeAgregarEditarComponent } from '../../cliente-sae/cliente-sae-agregar-editar/cliente-sae-agregar-editar.component';
import { contactoAddEditComponent } from '../../cliente-sae/cliente-sae-agregar-editar/contactos/contactoAddEddit.component';
//import { ModalSalidaVentaComponent } from '../agregar/modal-salida/modal-salida.component';

@Component({
  selector: 'my-venta-agregar',
  styleUrls: ['venta-agregar.scss'],
  templateUrl: 'venta-agregar.component.html',
  providers: [generalService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VentaAgregarComponent implements OnInit, OnDestroy {

    /***************************INFINITE SELECT**********************************/
    public viewDataClientes: any[];
    @ViewChild('infiniteSelectUnico') selectElemUnico: MatSelect;
    private itemsShow = 10;
    private filteredCliItemsShow = 10;
    private arrayFilteredCli = undefined;
    private isFilteredCli = false;
    @ViewChildren('infiniteSelect') selectElem: QueryList<MatSelect>;
    /***************************INFINITE SELECT**********************************/

    // ----------------------------------- DECLARACIÓN DE VARIABLES -----------------------------------
    public userData: any = JSON.parse(sessionStorage.getItem('user'));
    public datosGeneralesSAE: any;

    public DOCUMENT_ID: string;
    public VentaPedidoSelect = false;
    public lstTipoVenta: any[];
    public lstFamilia: any[];
    public lstSubfamilia: any[];
    public lstProducto: any[];
    public listaFormasPago: any[];
    public listaClientes: any[];
    public descripcionPorComp: boolean = false;
    public listaListasPrecios: any[];
    public listaClienteDirecciones: any[];
    public listaClienteSolicita: any[] = [];
    public frmVenta: FormGroup;

    public venta: Documento = new Documento();

    public PREVIOUS_DEBT = null;

    public titulo = '';
    public tituloFecha = '';

    public bandera = false;
    public banderaC = true;
    public webServ:string;
    public aux;
    public auxPagoVenta;


    public descuentoMonto: boolean = false;
    public descuentoPorcentaje: boolean = false;
    public habilitarFechaEntrega: boolean = false;
    public identificadorProductos: number = 0;
    public identificadorCargos: number = 0;
    public IVAPercent: number = 0;
    public tipoDescuento: boolean;
    public deshabilitarAddProduct: boolean = true;
    public ventaCerrada: boolean = false;
    public isCotizacion: boolean = false;
    public bloquearBtnGuardar = false;
    public funcionesActivadas: boolean = false;
    public clienteAlta:boolean = false;
    public idClienteAlta: number = null;
    public blockButtons: boolean = null;
    public esActualizacion: boolean = false;
    public vistaBtn : boolean;
    private idCompraVenta: string;

    public existeDeuda: boolean;

    public containsTaxGeneral = true;
    public ivaText = ''
    private loacs;
    public parametroUrl:any;
    public setdireccionEdicion = true;
    public setContacto = true;

    public VENTA_DESC_PCOMPRA: any;
    public VENTA_DESC_PCOMPRA_bandera = false;
    public VENTA_DESC_PCOMPRA_bandera_Pantalla = false;

    // ----------------------------------- DECLARACIÓN DE FUNCIONES -----------------------------------

    // ---------------- FUNCIONES DE CARGA ----------------
    constructor(private _generalService: generalService,
                private ref: ChangeDetectorRef,
                private route: ActivatedRoute,
                private router: Router,
                public dataService: DataService,
                public dialog: MatDialog,
                private formBuilder: FormBuilder,
                private pagoVentaService: PagoVentaService) {
        this.datosGeneralesSAE = DatosGeneralesSAE;
        this.venta.cliente = new Cliente();
        this.buildForm();
        this.idCompraVenta = this.route.snapshot.paramMap.get('id');
        this.route.params.forEach((params: Params)=>{
            this.parametroUrl = params['parametro'];
            console.log(this.parametroUrl);
          });
    }

    async ngOnInit() {
        this.loacs = sessionStorage.getItem("acslo");
        this.consultIVA();
        this.organizationDiscount();
        this.getDataFilters();
        // Esto es necesario para cambiar de parámetro en la página
        this.route.params.subscribe(async (routeParams) => {

            //setTimeout(() => {
                this.datosGeneralesSAE.showSpinnerLoading = true;
            //});

            this.DOCUMENT_ID = this.route.snapshot.paramMap.get('id');

            window.addEventListener('scroll', this.scrollPage, true);
            await this.cargarPantalla(false, null);

            this.modificarVenta();
            this.datosGeneralesSAE.showSpinnerLoading = false;

            /***************************INFINITE SELECT**********************************/
            this.selectElemUnico.onOpen.subscribe(() => this.registerPanelScrollEventUnico());
            /***************************INFINITE SELECT**********************************/
        });
        this.validarNombre()
    }

    ngOnDestroy() {
        this.pagoVentaService.seModificaraVentaPorPagar(false);
        window.removeEventListener('scroll', this.scrollPage, true);
    }

    modificarVenta() {
        if (this.pagoVentaService.seModificaraVenta()) {
            const ventaAModificar = this.pagoVentaService.obtenerVentaAAgregar();

            // IVA
            this.getIva();

            // Venta
            this.venta = ventaAModificar.Venta;
            if(this.venta.cliente === undefined || this.venta.cliente === null){
                this.venta.cliente = new Cliente();
            }

            this.consultarClienteDirecciones();
            this.consultarClienteSolicita();
            this.consultarListasPrecios();

            this.frmVenta.get('ClienteDireccion').setValue(ventaAModificar.CUSTOMER_ADDRESS_ID);


            if (this.venta.cliente.idCliente) {
                let clienteSeleccionado = this.listaClientes.filter(cliente => cliente.idCliente === this.venta.cliente.idCliente);
                let index = this.listaClientes.findIndex( e => e.idCliente === this.venta.cliente.idCliente);
                var a = this.listaClientes.splice(index,1);
                this.listaClientes.unshift(a[0]);

                this.viewDataClientes = this.listaClientes.slice(0, 10);

                if (clienteSeleccionado.length === 0) {
                    clienteSeleccionado = this.listaClientes.filter(cliente => cliente.idCliente === this.venta.cliente.idCliente);
                    if (clienteSeleccionado.length > 0) {
                        this.viewDataClientes.push(clienteSeleccionado[0]);
                    }
                }
            }

            console.log(ventaAModificar);

            this.venta.Productos = ventaAModificar.Productos;
            for (let i = 0; i < this.venta.Productos.length; i++) {
                this.identificadorProductos = ( this.venta.Productos[i].contProduct) ?  this.venta.Productos[i].contProduct : i + 1;
                this.venta.Productos[i].contProduct = (this.venta.Productos[i].contProduct) ?  this.venta.Productos[i].contProduct : i + 1;
                this.agregarcambiarProductoForm(this.identificadorProductos);
                this.identificadorProductos++;
                this.venta.Productos[i].identificador = this.venta.Productos[i].contProduct;
                // this.venta.Productos[i].lstFamilia = this.lstFamilia;
                // this.venta.Productos[i].lstSubfamilia = this.lstSubfamilia;
                this.venta.Productos[i].lstProducto = this.lstProducto;
                this.venta.Productos[i].lstProductoFiltradas = this.lstProducto.slice(0, 10);

                if(this.venta.Productos[i].lstProductoFiltradas.findIndex(x => x.ITEM_ID == this.venta.Productos[i].ITEM_ID) == -1){
                    var temp = this.venta.Productos[i].lstProducto.find(x => x.ITEM_ID == this.venta.Productos[i].ITEM_ID);
                    if(temp != undefined && temp != null){
                        this.venta.Productos[i].lstProductoFiltradas.unshift(temp);
                    }
                }

                if(this.venta.Productos[i].AMOUNT_DISCOUNT){
                    this.venta.Productos[i].descuentoMontoBool = true;
                }
                if(this.venta.Productos[i].PERCENTAGE_DISCOUNT){
                    this.venta.Productos[i].descuentoPorcentajeBool = true;
                }
            }

            this.venta.Cargos = ventaAModificar.Cargos;
            for (let i = 0; i < this.venta.Cargos.length; i++) {
                this.identificadorCargos =   ( this.venta.Cargos[i].contCargo) ?   this.venta.Cargos[i].contCargo : i + 1;
                this.venta.Cargos[i].contCargo =  ( this.venta.Cargos[i].contCargo) ?   this.venta.Cargos[i].contCargo : i + 1;
                this.agregarNuevoCargoForm(this.identificadorCargos);
                this.identificadorCargos++;
                this.venta.Cargos[i].identificador = this.venta.Cargos[i].contCargo;
            }

            this.datosGeneralesSAE.showSpinnerLoading = false;//Estaba comentado
            for (let i = 0; i < this.listaClientes.length; i++) {
                if(this.listaClientes[i].idCliente === this.venta.CUSTOMER_SUPPLIER_ID){
                    this.venta.cliente = this.listaClientes[i];
                    i = this.listaClientes.length;
                }
            }

            /*
            this.identificadorProductos = 0;
            for (let i = 0; i < this.venta.Productos.length; i++) {
                this.agregarcambiarProductoForm(this.identificadorProductos);

                this.venta.Productos[i].identificador = this.identificadorProductos;
                this.venta.Productos[i].lstFamilia = this.lstFamilia;
                this.venta.Productos[i].lstSubfamilia = this.lstSubfamilia;
                this.venta.Productos[i].lstProducto = this.lstProducto;
                this.venta.Productos[i].lstProductoFiltradas = this.lstProducto;

                if(this.venta.Productos[i].AMOUNT_DISCOUNT){
                    this.venta.Productos[i].descuentoMontoBool = true;
                }
                if(this.venta.Productos[i].PERCENTAGE_DISCOUNT){
                    this.venta.Productos[i].descuentoPorcentajeBool = true;
                }
            }

            this.venta.Cargos = ventaAModificar.Cargos;
            this.identificadorCargos = 0;
            for (let i = 0; i < this.venta.Cargos.length; i++) {
                this.agregarNuevoCargoForm(this.identificadorCargos);
                this.venta.Cargos[i].identificador = this.identificadorCargos;
                this.identificadorCargos++;
            } */

            this.ref.detectChanges();

        }

    }

    cargarPantalla(VentaPedidoSelect, tipoVentaOpcion): Promise<void> {
        const self = this
        return new Promise((resolve, reject) => {

            if (self.DOCUMENT_ID === 'N') {
            self.parametroUrl == ':parametro' ?  self.webServ = 'venta/cargarInformacionAgregarCompra?idUsuario=' :  self.webServ = 'venta/cargarInformacionAgregarVenta?idUsuario='
                self._generalService.requestGet(self.webServ + self.userData.USER_ID).subscribe(
                    (result) => {
                        var dataTemp: any = JSON.parse(result);
                        console.warn(dataTemp)
                        // IVA
                        self.IVAPercent = dataTemp.Table[0]["MEANING"];

                        // Tipo de venta
                        self.lstTipoVenta = dataTemp.Table1;

                        // Familias
                        //self.lstFamilia = dataTemp.Table2;                        

                        // Subfamilias
                        //self.lstSubfamilia = dataTemp.Table3;

                        // Productos
                        self.lstProducto = dataTemp.Table4;

                        // Tipos de pago
                        self.listaFormasPago = dataTemp.Table5;

                        // Clientes
                        self.listaClientes = dataTemp.Table6;

                        // Descripción por Compañia
                        self.descripcionPorComp = dataTemp.Table8.length>0? true:false;

                        // Check If Model Create At Client
                        self.selectClient();

                        /***************************INFINITE SELECT**********************************/
                        self.viewDataClientes = self.listaClientes.slice(0, 10);
                        /***************************INFINITE SELECT**********************************/

                        // Lista de Precios (Listas de precio consultadas por tipo de venta)
                        self.listaListasPrecios = dataTemp.Table7;

                        if (self.lstTipoVenta.length > 0 && !self.pagoVentaService.seModificaraVenta()) {
                            if(VentaPedidoSelect == true){
                                this.frmVenta.get('TipoVenta')?.setValue(tipoVentaOpcion);
                            }else{
                                self.venta.DOCUMENT_TYPE_ID = self.lstTipoVenta[0].DOCUMENT_TYPE_ID;
                                self.venta.METHOD_PAYMENT_ID = self.listaFormasPago[0].METHOD_PAYMENT_ID;
                            }
                           
                        }

                        self.ref.detectChanges();
                        self.datosGeneralesSAE.showSpinnerLoading = false;//Estaba comentado
                        resolve();
                        
                    },
                    (error) => {
                        const errorMsj =  error as any;
                        console.error(errorMsj);
                        reject();
                    }
                );
            }
            else{
                self.esActualizacion = true;
                self.parametroUrl == ':parametro' ?  self.webServ = 'venta/cargarInformacionVisualzarCompra?idUsuario=' :  self.webServ = 'venta/cargarInformacionVisualizarVenta?idUsuario='

                self._generalService.requestGet(self.webServ+ self.userData.USER_ID + "&idDocumento=" + self.DOCUMENT_ID).subscribe(
                    (result) => {
                        var dataTemp: any = JSON.parse(result);

                        // IVA
                        if(dataTemp.Table[0].MEANING){
                            self.IVAPercent = +dataTemp.Table[0].MEANING;
                        } else {
                            self.IVAPercent = null;
                        }

                        // Tipo de venta
                        self.lstTipoVenta = dataTemp.Table1;

                        // const ventaDirecta = self.lstTipoVenta.filter((obj) => {
                        //     return obj.NAME.trim() === 'Venta Directa';
                        // });

                        if (self.lstTipoVenta.length > 0) {
                            self.venta.DOCUMENT_TYPE_ID = self.lstTipoVenta[0].DOCUMENT_TYPE_ID;
                            self.ref.detectChanges();
                        }

                        // Familias
                        //self.lstFamilia = dataTemp.Table2;

                        // Subfamilias
                        //self.lstSubfamilia = dataTemp.Table3;

                        // Productos
                        self.lstProducto = dataTemp.Table4;

                        // Tipos de pago
                        self.listaFormasPago = dataTemp.Table5;

                        // Clientes
                        self.listaClientes = dataTemp.Table6;

                        // Check If Model Create At Client
                        self.selectClient();

                        self.viewDataClientes = self.listaClientes;

                        // Descripción por Compañia
                        self.descripcionPorComp = dataTemp.Table10.length>0? true:false;

                        // Lista de Precios (Listas de precio consultadas por tipo de venta)
                        //self.listaListasPrecios = dataTemp.Table7;

                        // Venta
                        self.venta = dataTemp.Table7[0];
                        
                        if(self.venta.cliente === undefined || self.venta.cliente === null){
                            self.venta.cliente = new Cliente();
                        }
                        if(self.venta.DOCUMENT_TYPE_ID === 3) {
                            if (self.dataService.acceso) {
                                self.DOCUMENT_ID = 'N';
                                self.venta.DOCUMENT_ID = null;
                                self.venta.DOCUMENT_NUMBER = null;
                                self.venta.DOCUMENT_TYPE_ID = null;
                                self.venta.ESTATUS = '';
                                self.venta.DOCUMENT_DATE = new Date();
                                self.lstTipoVenta.splice(2,1);
                            } else {
                                self.frmVenta.get('TipoVenta').disable();
                            }
                        }
                        else
                        {
                            self.lstTipoVenta.splice(2,1);
                            //self.frmVenta.get('TipoVenta').disable();
                        }
                        self.venta.MEANING = self.IVAPercent;
                        if(self.venta.DEBT !== undefined && self.venta.DEBT !== null) { // Tiene deuda
                            self.PREVIOUS_DEBT = self.venta.DEBT;
                            if(self.venta.TOTAL !== self.venta.DEBT){ // Tiene pago de por medio no se actualizara ninguna informacion
                                self.ventaCerrada = true;
                                self.frmVenta.get('TipoVenta').disable();
                                self.frmVenta.get('FormaPago').disable();
                                self.frmVenta.get('ClienteDireccion').disable();
                                self.frmVenta.get('InfoAdicional').disable();
                                self.frmVenta.get('FechaEntrega').disable();
                                self.frmVenta.get('FechaVenta').disable();
                                self.frmVenta.get('DescuentoPorcentajeVenta').disable();
                                self.frmVenta.get('DescuentoMontoVenta').disable();
                            }
                        }
                        if(self.venta.ESTATUS === 'CERRADA' && self.venta.DOCUMENT_TYPE_ID !== 3){
                                self.ventaCerrada = true;
                                self.frmVenta.get('TipoVenta').disable();
                                self.frmVenta.get('FormaPago').disable();
                                self.frmVenta.get('ClienteDireccion').disable();
                                self.frmVenta.get('InfoAdicional').disable();
                                self.frmVenta.get('FechaEntrega').disable();
                                self.frmVenta.get('FechaVenta').disable();
                                self.frmVenta.get('DescuentoPorcentajeVenta').disable();
                                self.frmVenta.get('DescuentoMontoVenta').disable();
                        }
                        //self.frmVenta.get('Cliente').disable();

                        /*let fecha = self.venta.DOCUMENT_DATE.split('-');
                        self.venta.DOCUMENT_DATE = new Date(fecha[0], fecha[1] - 1, fecha[2]);
                        fecha = self.venta.DELIVERY_COMMITMENT_DATE.split('-');
                        self.venta.DELIVERY_COMMITMENT_DATE = new Date(fecha[0], fecha[1] - 1, fecha[2]);*/

                        const nameDocumentType = self.lstTipoVenta.filter((obj) => {
                            return obj.DOCUMENT_TYPE_ID === self.venta.DOCUMENT_TYPE_ID;
                        });

                        if (nameDocumentType.length > 0) {
                            if (nameDocumentType[0].NAME === 'Venta Pedido') {
                                self.habilitarFechaEntrega = true;
                            }
                            if (nameDocumentType[0].NAME != 'Cotización')
                            {
                                self.frmVenta.get('Cliente').disable();
                            }else{
                                self.habilitarFechaEntrega = true;
                            }
                        }

                        self.venta.PERCENTAGE_DISCOUNT = (self.venta.PERCENTAGE_DISCOUNT === 0) ? undefined : self.venta.PERCENTAGE_DISCOUNT;
                        self.venta.AMOUNT_DISCOUNT = (self.venta.AMOUNT_DISCOUNT === 0) ? undefined : self.venta.AMOUNT_DISCOUNT;
                        if(self.venta.AMOUNT_UTILITY){
                            self.venta.UTILITY_INFO = self.venta.PERCENTAGE_UTILITY + "% / $" + self.venta.AMOUNT_UTILITY;
                        }


                        self.venta.Productos = dataTemp.Table8;
                        for (let i = 0; i < self.venta.Productos.length; i++) {
                            self.identificadorProductos = (dataTemp.Table8[i].contProduct) ? dataTemp.Table8[i].contProduct : i + 1;
                            self.venta.Productos[i].contProduct = (dataTemp.Table8[i].contProduct) ? dataTemp.Table8[i].contProduct : i + 1;
                            self.agregarcambiarProductoForm(self.identificadorProductos);
                            self.identificadorProductos++;
                            self.venta.Productos[i].identificador = dataTemp.Table8[i].contProduct;
                            // self.venta.Productos[i].lstFamilia = self.lstFamilia;
                            // self.venta.Productos[i].lstSubfamilia = self.lstSubfamilia;
                            self.venta.Productos[i].lstProducto = self.lstProducto;
                            self.venta.Productos[i].lstProductoFiltradas = self.lstProducto.slice(0, 10);

                            if(self.venta.Productos[i].lstProductoFiltradas.findIndex(x => x.ITEM_ID == self.venta.Productos[i].ITEM_ID) == -1){
                                var temp = self.venta.Productos[i].lstProducto.find(x => x.ITEM_ID == self.venta.Productos[i].ITEM_ID);
                                if(temp != undefined && temp != null){
                                    self.venta.Productos[i].lstProductoFiltradas.unshift(temp);
                                }
                            }

                            if(self.venta.Productos[i].AMOUNT_DISCOUNT){
                                self.venta.Productos[i].descuentoMontoBool = true;
                            }
                            if(self.venta.Productos[i].PERCENTAGE_DISCOUNT){
                                self.venta.Productos[i].descuentoPorcentajeBool = true;
                            }
                        }

                        self.venta.Cargos = dataTemp.Table9;
                        for (let i = 0; i < self.venta.Cargos.length; i++) {
                            self.identificadorCargos = dataTemp.Table9[i].contCargo;
                            self.agregarNuevoCargoForm(self.identificadorCargos);
                            self.identificadorCargos++;
                            self.venta.Cargos[i].identificador = dataTemp.Table9[i].contCargo;
                        }

                        self.datosGeneralesSAE.showSpinnerLoading = false;//Estaba comentado
                        for (let i = 0; i < self.listaClientes.length; i++) {
                            if(self.listaClientes[i].idCliente === self.venta.CUSTOMER_SUPPLIER_ID){
                                self.venta.cliente = self.listaClientes[i];
                                i = self.listaClientes.length;
                            }
                        }

                        self.consultarClienteDirecciones();
                        self.consultarClienteSolicita();
                        self.consultarListasPrecios();

                        //para no editar cuando tiene pagos o salidas
                        if (self.dataService.ventaEditable) {
                            self.frmVenta.disable();
                            self.ventaCerrada = true;
                            self.dataService.ventaEditable = false;

                            self.consultaPagosxVenta(self.DOCUMENT_ID);
                        }

                        resolve();
                        if(VentaPedidoSelect == true){
                            this.frmVenta.get('TipoVenta')?.setValue(tipoVentaOpcion);
                        }
                    },
                    (error) => {
                        const errorMsj =  error as any;
                        console.error(errorMsj);
                        reject();
                    }
                );
            }

           
        });
        

    }

    consultIVA() {
        this._generalService.metodoCallParams(this.loacs, 'itemLookUp/consultIVA')
            .subscribe(itemIVA => {
              itemIVA = JSON.parse(itemIVA);
              if(itemIVA.length > 0)
              {
                this.containsTaxGeneral = false;
                this.ivaText = 'IVA:'
              }
              else
              {
                this.containsTaxGeneral = true;
                this.ivaText = 'IVA (Incluído):'
              }
            }, error => {
              // Custom error handler
            });
      }

    // ------------- FUNCIONES DE FORMULARIO --------------
    buildForm() {
        this.frmVenta = this.formBuilder.group({
            TipoVenta: this.formBuilder.control({value: ''}, [Validators.required]),
            FormaPago: this.formBuilder.control({value: ''}, [Validators.required]),
            Cliente: this.formBuilder.control({value: ''}, null),
            ClienteDireccion: this.formBuilder.control({value: ''}, null),
            ClienteSolicita:this.formBuilder.control(0),
            InfoAdicional: this.formBuilder.control({value: ''}, null),
            FechaEntrega: this.formBuilder.control({value: ''}, null),
            FechaVenta: this.formBuilder.control({value: ''}, null),
            DescuentoPorcentajeVenta: this.formBuilder.control({value: ''}, null),
            DescuentoMontoVenta: this.formBuilder.control({value: ''}, null),
            UtilidadGeneral: this.formBuilder.control({value: '', disabled: true}, null)
        });
    }

    agregarcambiarProductoForm(indice: number) {
        //this.frmVenta.addControl('Familia' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, null));
        //this.frmVenta.addControl('Tipo' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, null));
        this.frmVenta.addControl('Producto' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, [Validators.required]));
        this.frmVenta.addControl('Cantidad' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, [Validators.required]));
        this.frmVenta.addControl('PrecioUnitario' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, [Validators.required]));
        this.frmVenta.addControl('DescuentoMonto' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, null));
        this.frmVenta.addControl('DescuentoPorcentaje' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, null));
        this.frmVenta.addControl('Total' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, null));
        this.frmVenta.addControl('DescripcionProducto' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, [Validators.maxLength(100)]));
        this.frmVenta.addControl(
            'TiempoEntrega' + indice,
            this.formBuilder.control({ value: '', disabled: this.ventaCerrada }, [Validators.maxLength(100)])
        );
    }

    eliminarProductoForm(indice: number) {
        //this.frmVenta.removeControl('Familia' + indice);
        //this.frmVenta.removeControl('Tipo' + indice);
        this.frmVenta.removeControl('Producto' + indice);
        this.frmVenta.removeControl('Cantidad' + indice);
        this.frmVenta.removeControl('PrecioUnitario' + indice);
        this.frmVenta.removeControl('DescuentoMonto' + indice);
        this.frmVenta.removeControl('DescuentoPorcentaje' + indice);
        this.frmVenta.removeControl('Total' + indice);
        this.frmVenta.removeControl('DescripcionProducto' + indice);
        this.frmVenta.removeControl('TiempoEntrega' + indice);
    }

    agregarNuevoCargoForm(indice: number) {
        this.frmVenta.addControl('Descripcion' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, [Validators.required, Validators.maxLength(100)]));
        this.frmVenta.addControl('TotalCargo' + indice, this.formBuilder.control({value: '', disabled: this.ventaCerrada}, [Validators.required]));
    }

    eliminarCargoForm(indice: number) {
        this.frmVenta.removeControl('TotalCargo' + indice);
        this.frmVenta.removeControl('Descripcion' + indice);
    }

    // ---------- FUNCIONES DE ACCIONES DE VENTA ----------
    actionDocument(tipo: number) {
        this.blockButtons = true;
        this.datosGeneralesSAE.showSpinnerLoading = true;

        const productosFilter = this.venta.Productos.filter((prod) => { return prod.ITEM_ID !== null && prod.ITEM_ID !== undefined; });
        const cargosFilter = this.venta.Cargos.filter((carg) => { return carg.COMMENTS !== null && carg.COMMENTS !== undefined && carg.TOTAL !== null && carg.TOTAL !== undefined; });
        this.venta.Productos = productosFilter;
        this.venta.Cargos = cargosFilter;

        if(this.venta.Productos.length > 0 || this.venta.Cargos.length > 0) { //this.frmVenta.valid &&
            if (this.DOCUMENT_ID === 'N') {
                if (tipo === 2) {
                    this.realizarPagoDirecto();
                } else {
                    this.insertDocument(tipo);
                }
            } else {
                if (tipo === 2) {
                    this.realizarPagoDirecto();
                } else {
                    this.updateDocument(tipo);
                }
            }
        } else {
            this.datosGeneralesSAE.showSpinnerLoading = false;
            this.blockButtons = false;
        }
    }

    realizarPagoDirecto() {


        const documentAgregar = this.obtenerDocumentAgregar();
        this.pagoVentaService.pagarVenta(documentAgregar, this.venta.cliente);
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this.blockButtons = false;
    }

    insertDocument(tipo: number) {
        // Se obtienen los parámetros que se enviarán a la función que guarda la venta
        const documentAgregar = this.obtenerDocumentAgregar();
        this.parametroUrl == ':parametro' ?  this.webServ = 'venta/InsertDocumentCompra?idUsuario=' :  this.webServ = 'venta/InsertDocument?idUsuario='
        this._generalService.requestPostParams(documentAgregar,this.webServ).subscribe(
            (result) => {
                if (result !== 'La venta se registró correctamente') {
                    this.datosGeneralesSAE.showSpinnerLoading = false;
                    this.blockButtons = false;
                    this.ventaCerrada = false;
                    this.modal('alert', result);
                    //this.parametroUrl == ':parametro' ? this.router.navigate(['app/compra/:parametro']) : this.router.navigate(['app/venta'])
                }else if (result !== 'La compra se registró correctamente') {
                    this.datosGeneralesSAE.showSpinnerLoading = false;
                    this.blockButtons = false;
                    this.ventaCerrada = false;
                    this.modal('alert', result);
                    this.parametroUrl == ':parametro' ? this.router.navigate(['app/compra/:parametro']) : this.router.navigate(['app/venta'])
                }
                else {
                    this._generalService.toastCall(result);
                    if (tipo === 1) {
                        this.datosGeneralesSAE.showSpinnerLoading = false;
                        this.blockButtons = false;
                        this.parametroUrl == ':parametro' ? this.router.navigate(['app/compra/:parametro']) : this.router.navigate(['app/venta'])

                    } else {
                        this.realizarPagoDirecto();
                    }
                }
            },
            (error) => {
                console.error(error as any);
            }
        );
    }

    updateDocument(tipo: number) {
        // Se obtienen los parámetros que se enviarán a la función que guarda la venta
        const documentAgregar = this.obtenerDocumentAgregar();
        this._generalService.requestPostParams(documentAgregar, 'venta/UpdateDocument/').subscribe(
            (result) => {
                if (result !== 'La venta se actualizó correctamente') {
                    this.datosGeneralesSAE.showSpinnerLoading = false;
                    this.blockButtons = false;
                    this.ventaCerrada = false;
                    this.modal('alert', result);
                }
                else {
                    if (tipo === 1) {
                        this.datosGeneralesSAE.showSpinnerLoading = false;
                        this.blockButtons = false;
                        //this.router.navigate(['app/venta']);
                        this.parametroUrl == ':parametro' ? this.router.navigate(['app/compra/:parametro']) : this.router.navigate(['app/venta'])
                    } else {
                        this.realizarPagoDirecto();
                    }
                }
            },
            (error) => {
                console.error(error as any);
            }
        );
    }

    obtenerDocumentAgregar(): DocumentAgregar {
        let status = 'cerrada';

         // en caso de que sea una compra
        if (this.bandera == false){
            this.venta.DOCUMENT_TYPE_ID = 7;
        }

        if (this.venta.DOCUMENT_TYPE_ID !== 3 ) {
            status = 'deuda pendiente';
            if (this.venta.CUSTOMER_SUPPLIER_ID > 0) {
                this.venta.DEBT = this.venta.TOTAL;
            }
        }

        if (this.venta.cliente) {
            this.venta.cliente.Nombre = this.venta.cliente.razonSocial;
        }

        if(this.venta.DOCUMENT_TYPE_ID == 1) {
            this.venta.DELIVERY_COMMITMENT_DATE = this.venta.DOCUMENT_DATE;
        }

        this.venta.DOCUMENT_DATE = new Date(this.venta.DOCUMENT_DATE).toISOString();
        this.venta.DELIVERY_COMMITMENT_DATE = new Date(this.venta.DELIVERY_COMMITMENT_DATE).toISOString();
        this.venta.PREVIOUS_DEBT = (this.PREVIOUS_DEBT !== null && this.PREVIOUS_DEBT !== undefined) ? this.PREVIOUS_DEBT : 0;
        this.parametroUrl == ':parametro' ? this.auxPagoVenta = 1 : this.auxPagoVenta = 2

        let clienteSolicita = this.frmVenta.get('ClienteSolicita').value;

        if(this.venta.DOCUMENT_TYPE_ID != 3 || clienteSolicita == 0){
            this.venta.CUSTOMER_SUPPLIER_CONTACT_ID = 0;
        }else{
            this.venta.CUSTOMER_SUPPLIER_CONTACT_ID = this.frmVenta.get('ClienteSolicita').value as number
        }






        const documentAgregar: DocumentAgregar = {
            Venta: Object.assign({}, this.venta),
            Productos: this.venta.Productos.map(x => Object.assign({}, x)),
            Cargos: this.venta.Cargos.map(x => Object.assign({}, x)),
            NOMENCLATURA: this.isCotizacion ? 'CO' : this.bandera ? 'VN' : 'COM',
            USER_ID: this.userData.USER_ID,
            ORGANIZATION_ID: this.userData.ORGANIZATION_ID,
            STATUS: status,
            CUSTOMER_ADDRESS_ID: this.venta.CUSTOMER_ADDRESS_ID,
            CUSTOMER_SUPPLIER_CONTACT_ID:this.venta.CUSTOMER_SUPPLIER_CONTACT_ID,

        };

        if (documentAgregar.Venta.PERCENTAGE_DISCOUNT) {
            // Si se ingreso descuento general a la venta se calculará cuanto fue lo que pago por cada producto descontando el descuento
            for (let i = 0; i < documentAgregar.Productos.length; i++) {
                documentAgregar.Productos[i].TOTAL_GLOBAL_DISCOUNT =
                    Number((documentAgregar.Productos[i].TOTAL * (Number(documentAgregar.Venta.PERCENTAGE_DISCOUNT) / 100)).toFixed(2));
            }
            for (let i = 0; i < documentAgregar.Cargos.length; i++) {
                documentAgregar.Cargos[i].TOTAL_GLOBAL_DISCOUNT =
                    Number((documentAgregar.Cargos[i].TOTAL * (Number(documentAgregar.Venta.PERCENTAGE_DISCOUNT) / 100)).toFixed(2));
            }
        } else {
            // Si no se ingreso descuento general, el total ya con descuento es igual al total ((precio unitario * cantidad) - descuento individual)
            for (let i = 0; i < documentAgregar.Productos.length; i++) {
                documentAgregar.Productos[i].TOTAL_GLOBAL_DISCOUNT = 0;
            }
            for (let i = 0; i < documentAgregar.Cargos.length; i++) {
                documentAgregar.Cargos[i].TOTAL_GLOBAL_DISCOUNT = 0;
            }
        }

        documentAgregar.Venta.Productos = [];
        documentAgregar.Venta.Cargos = [];
        for (let i = 0; i < documentAgregar.Productos.length; i++) {
            documentAgregar.Productos[i].lstFamilia = [];
            documentAgregar.Productos[i].lstSubfamilia = [];
            documentAgregar.Productos[i].lstProducto = [];
            documentAgregar.Productos[i].lstProductoFiltradas = [];
        }

        for (let i = 0; i < documentAgregar.Cargos.length; i++) {
            documentAgregar.Cargos[i].lstFamilia = [];
            documentAgregar.Cargos[i].lstSubfamilia = [];
            documentAgregar.Cargos[i].lstProducto = [];
            documentAgregar.Cargos[i].lstProductoFiltradas = [];
        }

        return documentAgregar;
    }

    // ------------ FUNCIONES DE VENTA GENERAL ------------
    cambiarTipoVenta(event: any) {
        if (this.venta.DOCUMENT_TYPE_ID == 1) {
            this.habilitarFechaEntrega = false;
            this.venta.DELIVERY_COMMITMENT_DATE = this.venta.DOCUMENT_DATE;
            this.isCotizacion = false;
        }

        if (this.venta.DOCUMENT_TYPE_ID == 2) {
            this.habilitarFechaEntrega = true;
            this.venta.DELIVERY_COMMITMENT_DATE = this.venta.DOCUMENT_DATE;
            this.isCotizacion = false;
        }

        if (this.venta.DOCUMENT_TYPE_ID == 3) {
            // this.habilitarFechaEntrega = false;
            this.habilitarFechaEntrega = true;
            this.venta.DELIVERY_COMMITMENT_DATE = this.venta.DOCUMENT_DATE;
            this.isCotizacion = true;
        }
        else{
            this.isCotizacion = false;
        }

        this.consultarListasPrecios();
    }

    cambiarFechaVenta() {
        if (this.habilitarFechaEntrega) {
            if(this.venta.DELIVERY_COMMITMENT_DATE < this.venta.DOCUMENT_DATE){
                this.venta.DELIVERY_COMMITMENT_DATE = this.venta.DOCUMENT_DATE;
            }
        }
    }

    calcularDescuentoVenta(opcion: number) {
        if(this.funcionesActivadas){
            let subotal = 0;
            for (let i: number = 0; i < this.venta.Productos.length; i++) {
                if (this.venta.Productos[i].ITEM_ID) {
                    subotal += Number(this.venta.Productos[i].TOTAL);
                }
            }

            for (let i: number = 0; i < this.venta.Cargos.length; i++) {
                if (this.venta.Cargos[i].TOTAL && this.venta.Cargos[i].COMMENTS) {
                    subotal += Number(this.venta.Cargos[i].TOTAL);
                }
            }

            // Se cambio el descuento por porcentaje
            if(opcion == 1){
                let descuento;
                if(this.VENTA_DESC_PCOMPRA_bandera && this.VENTA_DESC_PCOMPRA_bandera_Pantalla && this.venta.PERCENTAGE_DISCOUNT){
                    descuento = subotal / (1 + (Number(this.venta.PERCENTAGE_DISCOUNT) / 100));
                    descuento = this.venta.SUBTOTAL - descuento;
                }else{
                    descuento = subotal * (Number(this.venta.PERCENTAGE_DISCOUNT) / 100)
                }
                this.funcionesActivadas = false;
                this.venta.AMOUNT_DISCOUNT = Number(descuento.toFixed(2));
                this.frmVenta.get('DescuentoMontoVenta').setValue(Number(descuento.toFixed(2)));

                this.funcionesActivadas = true;
                this.calcularTotalesVenta();
            }

            // Se cambio el descuento por monto
            if(opcion == 2){
                if(Number(this.venta.AMOUNT_DISCOUNT) > subotal){
                    this.venta.AMOUNT_DISCOUNT = subotal;
                }
                
                let porcentajeDescuento = 0;
                porcentajeDescuento = (Number(this.venta.AMOUNT_DISCOUNT) * 100) / subotal;

                this.funcionesActivadas = false;
                this.venta.PERCENTAGE_DISCOUNT = Number((porcentajeDescuento).toFixed(2));
                this.frmVenta.get('DescuentoPorcentajeVenta').setValue(Number((porcentajeDescuento).toFixed(2)));

                this.funcionesActivadas = true;
                this.calcularTotalesVenta();
            }

            // Se cambio la información de un producto
            if(opcion == 3){
                let descuento = subotal * (Number(this.venta.PERCENTAGE_DISCOUNT) / 100);

                this.funcionesActivadas = false;
                this.venta.AMOUNT_DISCOUNT = Number(descuento.toFixed(2));
                this.frmVenta.get('DescuentoMontoVenta').setValue(Number(descuento.toFixed(2)));
                this.funcionesActivadas = true;

            }
        }
    }

    calcularTotalesVenta() {
        let subotal = 0;
        for (let i: number = 0; i < this.venta.Productos.length; i++) {
            if (this.venta.Productos[i].ITEM_ID) {
                subotal += Number(this.venta.Productos[i].TOTAL);
            }
        }

        for (let i: number = 0; i < this.venta.Cargos.length; i++) {
            if (this.venta.Cargos[i].TOTAL && this.venta.Cargos[i].COMMENTS) {
                subotal += Number(this.venta.Cargos[i].TOTAL);
            }
        }

        let descuento = 0;
        
        if(this.venta.AMOUNT_DISCOUNT){
            descuento = this.venta.AMOUNT_DISCOUNT;
        }

        this.venta.SUBTOTAL = Number((subotal).toFixed(2));
        this.venta.TOTAL = this.venta.SUBTOTAL - descuento;
        this.venta.IVA = Number((this.venta.TOTAL - (this.venta.TOTAL / ((this.IVAPercent / 100) + 1))).toFixed(2));

        if(!this.containsTaxGeneral && !this.VENTA_DESC_PCOMPRA_bandera){
            this.venta.IVA = Number(((subotal - descuento)  * (this.IVAPercent / 100)).toFixed(2));
            this.venta.TOTAL = Number(((this.venta.SUBTOTAL - descuento) + this.venta.IVA).toFixed(2));
        }else{
            let total = 0;
            if(this.VENTA_DESC_PCOMPRA_bandera && this.VENTA_DESC_PCOMPRA_bandera_Pantalla && this.venta.PERCENTAGE_DISCOUNT){
                total = this.venta.SUBTOTAL / (1 + (Number(this.venta.PERCENTAGE_DISCOUNT) / 100));
            }else{
                //total = (this.venta.SUBTOTAL - this.venta.PERCENTAGE_DISCOUNT);   
                total = Number((this.venta.SUBTOTAL - descuento).toFixed(2));
            }
            //this.venta.TOTAL = total
            this.venta.TOTAL = Number(total.toFixed(2));
            this.venta.IVA = Number((this.venta.TOTAL - (this.venta.TOTAL / ((this.IVAPercent / 100) + 1))).toFixed(2));
        }

        this.calcularUtilidad();
    }

    calcularUtilidad(){
        let costo = 0;
        let sumaCostos = 0;
        let total = 0;
        let sumaTotales = 0;

        let utilidadIndividual = 0;

        for (let i: number = 0; i < this.venta.Productos.length; i++) {
            if (this.venta.Productos[i].ITEM_ID) {
                // Calculo del costo de todas las cantidades
                if(this.venta.Productos[i].PURCHASE_TOTAL) {
                    costo = this.venta.Productos[i].PURCHASE_TOTAL;
                }
                else {
                    this.venta.Productos[i].PURCHASE_TOTAL = Number((Number(this.venta.Productos[i].BASE_PURCHASE_PRICE) * Number(this.venta.Productos[i].QUANTITY)).toFixed(2));
                    costo = this.venta.Productos[i].PURCHASE_TOTAL;
                }
                sumaCostos += costo;

                // Calculo del total en base a todas las cantidades
                if(this.venta.PERCENTAGE_DISCOUNT){
                    total = Number((this.venta.Productos[i].TOTAL - (this.venta.Productos[i].TOTAL * (Number(this.venta.PERCENTAGE_DISCOUNT) / 100))).toFixed(2));
                }
                else{
                    total = this.venta.Productos[i].TOTAL;
                }
                sumaTotales += total;

                // Calculo de la utilidad para cada registro de producto
                let utilidadIndividual = Number((total - costo).toFixed(2));
                this.venta.Productos[i].AMOUNT_UTILITY = utilidadIndividual;
                this.venta.Productos[i].PERCENTAGE_UTILITY = Number(((utilidadIndividual * 100) / costo).toFixed(2));
            }
        }

        sumaCostos = Number(sumaCostos.toFixed(2));
        sumaTotales = Number(sumaTotales.toFixed(2));

        let utilidad = Number((sumaTotales - sumaCostos).toFixed(2));

        this.venta.PURCHASE_TOTAL = sumaCostos;
        this.venta.AMOUNT_UTILITY = utilidad;
        if(sumaCostos > 0){
            this.venta.PERCENTAGE_UTILITY = Number(((utilidad * 100) / sumaCostos).toFixed(2));
        } else {
            this.venta.PERCENTAGE_UTILITY = 0;
        }
        this.venta.UTILITY_INFO = this.venta.PERCENTAGE_UTILITY + "% / $" + this.venta.AMOUNT_UTILITY;
    }


    // --------------- FUNCIONES PRODUCTOS ----------------
    agregarProducto(opcion: number) {
        if(opcion == 1){
            if (this.venta.Productos.length > 0) {
                if (!this.venta.Productos[this.venta.Productos.length - 1].ITEM_ID && !this.venta.Productos[this.venta.Productos.length - 1].PRICE && !this.venta.Productos[this.venta.Productos.length - 1].QUANTITY)
                {
                    return;
                }
            }
        }

        let prod: DocumentoDetalle = new DocumentoDetalle();
        prod.identificador = this.identificadorProductos;
        prod.lstFamilia = this.lstFamilia
        prod.lstSubfamilia = this.lstSubfamilia;
        prod.lstProducto = this.lstProducto;
        prod.lstProductoFiltradas = this.lstProducto.slice(0, 10);
        prod.ITEM_FAMILY_ID = undefined;
        prod.ITEM_SUBFAMILY_ID = undefined;
        /***************************INFINITE SELECT**********************************/
        prod.itemsShow = 10;
        prod.arrayFilteredProd = undefined;
        prod.filteredItemsShow = 10;
        prod.isFilteredProd = false;
        /***************************INFINITE SELECT**********************************/
        this.venta.Productos.push(prod);

        this.agregarcambiarProductoForm(this.identificadorProductos);
        this.identificadorProductos++;

        if (!this.ventaCerrada && opcion != 2) {
            setTimeout(() =>
                document.getElementById('productoItem' + (this.venta.Productos.length - 1)).click(),
            0);
            setTimeout(() => document.getElementById('SearchProduct' + (this.venta.Productos.length - 1)).focus(), 1);
        }

        if(!this.ventaCerrada) {
            /***************************INFINITE SELECT**********************************/
            setTimeout(() =>
                this.selectElem.toArray().forEach(el => {el.onOpen.subscribe(() => this.registerPanelScrollEvent(el));}),
            2);
            //this.selectElem.toArray()[this.venta.Productos.length-1].onOpen.subscribe(() => this.registerPanelScrollEvent(this.selectElem.toArray()[this.venta.Productos.length-1]))
            /*
            
            */
            /***************************INFINITE SELECT**********************************/
        }
    }

    cambiarFamiliaSubfamilia(product: DocumentoDetalle, opcion: number) {
        if (opcion == 1) {
            product.ITEM_SUBFAMILY_ID = undefined;
            product.ITEM_ID = undefined;

            product.lstSubfamilia = this.lstSubfamilia.filter((obj) => {
                return obj.ITEM_FAMILY_ID === product.ITEM_FAMILY_ID;
            });
            product.lstProducto = this.lstProducto.filter((obj) => {
                return obj.ITEM_FAMILY_ID === product.ITEM_FAMILY_ID;
            });
        }

        if (opcion == 2) {
            product.ITEM_ID = undefined;
            product.lstProducto = this.lstProducto.filter((obj) => {
                return obj.ITEM_SUBFAMILY_ID === product.ITEM_SUBFAMILY_ID;
            });
        }

        product.searchProduct = undefined;
        product.lstProductoFiltradas = product.lstProducto;
        product.QUANTITY = undefined;
        product.PRICE = undefined;
        product.BASE_PURCHASE_PRICE = undefined;
        product.BASE_SALE_PRICE = undefined;
        product.TOTAL = undefined;

        product.descuentoMontoBool = false;
        product.descuentoPorcentajeBool = false;

        product.AMOUNT_DISCOUNT = undefined;
        product.PERCENTAGE_DISCOUNT = undefined;
        product.PURCHASE_TOTAL = undefined;
        product.AMOUNT_UTILITY = undefined;
        product.PERCENTAGE_UTILITY = undefined;

        // Se vuelven a calcular los descuentos de la venta y los totales
        if(this.venta.AMOUNT_DISCOUNT){
            this.funcionesActivadas = true;
            this.calcularDescuentoVenta(3);
            this.funcionesActivadas = false;
        }
        this.calcularTotalesVenta();
    }

    // filtrarProductos(product: DocumentoDetalle) {
    //     let arr: any[];
    //     if (product.searchProduct) {
    //         product.arrayFilteredProd = product.lstProducto.filter((obj) => {
    //             return obj.NAME.toLowerCase().indexOf(product.searchProduct.toLowerCase()) > -1 || ((obj.SKU) ? obj.SKU : '').toLowerCase().indexOf(product.searchProduct.toLowerCase()) > -1 || ((obj.BARCODE) ? obj.BARCODE : '').toLowerCase().indexOf(product.searchProduct.toLowerCase()) > -1;
    //         });

    //         arr = product.arrayFilteredProd.slice(0, product.filteredItemsShow);
    //         product.isFilteredProd = true;
    //     }
    //     else {
    //         product.isFilteredProd = false;
    //         product.filteredItemsShow = 10;
    //         product.arrayFilteredProd = undefined;
    //         /***************************INFINITE SELECT**********************************/
    //         arr = product.lstProducto.slice(0, product.itemsShow);
    //         /***************************INFINITE SELECT**********************************/
    //     }
    //     product.lstProductoFiltradas = arr;
    // }

    private normalizeText(s: any): string {
        return (s ?? '')
            .toString()
            .toLowerCase()
            .normalize('NFD')                 // quita acentos
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9\s-]/g, ' ')    // quita signos raros (deja letras, num, espacios, guión)
            .replace(/\s+/g, ' ')
            .trim();
    }

    private tokenize(s: any): string[] {
        return this.normalizeText(s)
            .split(' ')
            .filter(t => t.length >= 2);      // ignora tokens muy cortos (ajusta si quieres)
    }

    filtrarProductos(product: DocumentoDetalle) {
        let arr: any[];

        const tokens = this.tokenize(product.searchProduct);

        if (tokens.length) {
            product.arrayFilteredProd = product.lstProducto.filter((obj: any) => {
                // buscamos en NAME, SKU y BARCODE (manteniendo tu intención)
                const haystack = this.normalizeText(
                    `${obj.NAME || ''} ${obj.SKU || ''} ${obj.BARCODE || ''}`
                );

                // AND: todas las palabras tecleadas deben aparecer en alguno de esos campos
                return tokens.every(t => haystack.includes(t));
            });

            // (opcional) si quieres priorizar coincidencias más fuertes, puedo rankear aquí
            arr = product.arrayFilteredProd.slice(0, product.filteredItemsShow);
            product.isFilteredProd = true;
        } else {
            product.isFilteredProd = false;
            product.filteredItemsShow = 10;
            product.arrayFilteredProd = undefined;

            arr = product.lstProducto.slice(0, product.itemsShow);
        }

        product.lstProductoFiltradas = arr;
    }



    filtrarCliente(clienteTerm) {
        let clientesFiltrados = [];
        if (clienteTerm && clienteTerm != '') {
            this.arrayFilteredCli = this.listaClientes.filter((cliente) => {
                return cliente.razonSocial.toLowerCase().indexOf(clienteTerm.toLowerCase()) > -1;
            });

            clientesFiltrados = this.arrayFilteredCli.slice(0, this.filteredCliItemsShow);
            this.isFilteredCli = true;
        } else {
            this.isFilteredCli = false;
            this.filteredCliItemsShow = 10;
            this.arrayFilteredCli = undefined;
            clientesFiltrados = this.listaClientes.slice(0, this.itemsShow);
        }
        this.viewDataClientes = clientesFiltrados;
    }
    previewImagen:string=""
    cambiarProducto(product: DocumentoDetalle, indice: number) {
        this.previewImagen=""
        const productoElegido = this.lstProducto.filter((obj) => {
            return obj.ITEM_ID === product.ITEM_ID;
        });
        console.warn(productoElegido)
        if (productoElegido[0].FILE!=null) {
            this.previewImagen=productoElegido[0].FILE
        }
        // product.QUANTITY = 1;
        // product.BASE_SALE_PRICE = productoElegido[0].BASE_SALE_PRICE;
        // product.PRICE = productoElegido[0].BASE_SALE_PRICE;

        if (this.banderaC){
            product.QUANTITY = 1;
            product.BASE_PURCHASE_PRICE = productoElegido[0].BASE_PURCHASE_PRICE;
            product.PRICE = productoElegido[0].BASE_PURCHASE_PRICE;
        }else{
            product.QUANTITY = 1;
            product.BASE_SALE_PRICE = productoElegido[0].BASE_SALE_PRICE;
            product.PRICE = productoElegido[0].BASE_SALE_PRICE;
        }
        // Se verifica si se tiene que cambiar el precio unitario en base a una lista de precio
        this.aplicarListasPrecios(product);

        product.BASE_PURCHASE_PRICE = productoElegido[0].BASE_PURCHASE_PRICE;
        product.PURCHASE_TOTAL = productoElegido[0].BASE_PURCHASE_PRICE;
        product.CONTAINS_TAX = productoElegido[0].CONTAINS_TAX;

        product.AMOUNT_DISCOUNT = undefined;
        product.PERCENTAGE_DISCOUNT = undefined;

        // Se limpian porque se calculan después de haber recalculado todo los totales
        product.AMOUNT_UTILITY = undefined;
        product.PERCENTAGE_UTILITY = undefined;

        product.descuentoMontoBool = false;
        product.descuentoPorcentajeBool = false;

        // Se calcula el nuevo total del producto de venta
        this.funcionesActivadas = true;
        this.calcularTotalProducto(product);
        this.funcionesActivadas = false;

        this.permitirDecimales(product);

        product.STOCK = productoElegido[0].STOCK;

        if ((indice + 1) === this.venta.Productos.length) {
            this.agregarProducto(2);
        }
    }

    cambioCantidad(product: DocumentoDetalle){
        if(this.funcionesActivadas){
            product.PURCHASE_TOTAL = Number((Number(product.BASE_PURCHASE_PRICE) * Number(product.QUANTITY)).toFixed(2));

            // Se limpian porque se calculan después de haber recalculado todo los totales
            product.AMOUNT_UTILITY = undefined;
            product.PERCENTAGE_UTILITY = undefined;

            // Se verifica si se tiene que cambiar el precio unitario en base a una lista de precio
            this.aplicarListasPrecios(product);

            // Se calcula el nuevo total del producto de venta
            this.calcularTotalProducto(product);
        }
    }

    cambioPrecioUnitario(product: DocumentoDetalle){
        if(this.funcionesActivadas){
            // Se limpian porque se calculan después de haber recalculado todo los totales
            product.AMOUNT_UTILITY = undefined;
            product.PERCENTAGE_UTILITY = undefined;
            this.calcularTotalProducto(product);
        }
    }

    calcularTotalProducto(product: DocumentoDetalle) {
        if(this.funcionesActivadas){

            const cant = Number(product.QUANTITY);
            const precioUnitario = Number(product.PRICE);
            const totalSinDescuentos = cant * precioUnitario;

            let descuento = 0;



            if(product.AMOUNT_DISCOUNT){
                descuento = Number(product.AMOUNT_DISCOUNT);
            }
            if(product.PERCENTAGE_DISCOUNT){
                descuento = totalSinDescuentos * (Number(product.PERCENTAGE_DISCOUNT) / 100);
            }

            let IvaVal = 0;
            if (product.CONTAINS_TAX) {
                IvaVal = totalSinDescuentos * (this.IVAPercent / 100);
            }

            let total = 0;
            if(this.VENTA_DESC_PCOMPRA_bandera && this.VENTA_DESC_PCOMPRA_bandera_Pantalla && product.PERCENTAGE_DISCOUNT){
                //descuento VENTA_DESC_PCOMPRA y solo Ventas
                total = totalSinDescuentos / (1 + (Number(product.PERCENTAGE_DISCOUNT) / 100));
            }else{
                total = (totalSinDescuentos - descuento);
            }
            product.TOTAL = Number(total.toFixed(2));


            // Se vuelven a calcular los descuentos de la venta y los totales
            if(this.venta.AMOUNT_DISCOUNT){
                this.calcularDescuentoVenta(3);
            }
            this.calcularTotalesVenta();

            this.funcionesActivadas = false;
            this.ref.detectChanges();
            this.funcionesActivadas = true;
        }
    }

    toggleDescuentoMonto(product: DocumentoDetalle) {
        if (!this.ventaCerrada && product.ITEM_ID) {
            product.descuentoMontoBool = true;
            product.descuentoPorcentajeBool = false;

            product.AMOUNT_DISCOUNT = undefined;
            product.PERCENTAGE_DISCOUNT = undefined;

            // Se limpian porque se calculan después de haber recalculado todo los totales
            product.AMOUNT_UTILITY = undefined;
            product.PERCENTAGE_UTILITY = undefined;

            this.frmVenta.get('DescuentoMonto' + product.identificador).clearValidators();
            this.frmVenta.get('DescuentoMonto' + product.identificador).updateValueAndValidity();

            this.frmVenta.get('DescuentoPorcentaje' + product.identificador).clearValidators();
            this.frmVenta.get('DescuentoPorcentaje' + product.identificador).updateValueAndValidity();

            this.frmVenta.get('DescuentoMonto' + product.identificador).setValidators([Validators.required]);
            this.frmVenta.get('DescuentoMonto' + product.identificador).updateValueAndValidity();

            this.funcionesActivadas = true;
            this.calcularTotalProducto(product);
            this.funcionesActivadas = false;
        }
    }

    toggleDescuentoPorcentaje(product: DocumentoDetalle) {
        if (!this.ventaCerrada && product.ITEM_ID) {
            product.descuentoMontoBool = false;
            product.descuentoPorcentajeBool = true;

            product.AMOUNT_DISCOUNT = undefined;
            product.PERCENTAGE_DISCOUNT = undefined;

            // Se limpian porque se calculan después de haber recalculado todo los totales
            product.AMOUNT_UTILITY = undefined;
            product.PERCENTAGE_UTILITY = undefined;

            this.frmVenta.get('DescuentoMonto' + product.identificador).clearValidators();
            this.frmVenta.get('DescuentoMonto' + product.identificador).updateValueAndValidity();

            this.frmVenta.get('DescuentoPorcentaje' + product.identificador).clearValidators();
            this.frmVenta.get('DescuentoPorcentaje' + product.identificador).updateValueAndValidity();

            this.frmVenta.get('DescuentoPorcentaje' + product.identificador).setValidators([Validators.required]);
            this.frmVenta.get('DescuentoPorcentaje' + product.identificador).updateValueAndValidity();

            this.funcionesActivadas = true;
            this.calcularTotalProducto(product);
            this.funcionesActivadas = false;
        }
    }

    cambiarDescuento(product: DocumentoDetalle, opcion: number){
        if(this.funcionesActivadas){
            if(opcion == 1){
                const cant = Number(product.QUANTITY);
                const precioUnitario = Number(product.PRICE);
                const totalSinDescuentos = cant * precioUnitario;

                if(Number(product.AMOUNT_DISCOUNT) > totalSinDescuentos){
                    this.funcionesActivadas = false;
                    product.AMOUNT_DISCOUNT = Number(totalSinDescuentos.toString());
                    this.frmVenta.get('DescuentoMonto' + product.identificador).setValue(Number(totalSinDescuentos.toString()));
                }
            }

            // Se limpian porque se calculan después de haber recalculado todo los totales
            product.AMOUNT_UTILITY = undefined;
            product.PERCENTAGE_UTILITY = undefined;

            this.funcionesActivadas = true;
            this.calcularTotalProducto(product);
        }
    }

    eliminarProducto(indice: number) {
        this.eliminarProductoForm(this.venta.Productos[indice].identificador);
        this.venta.Productos.splice(indice, 1);
        /***************************INFINITE SELECT**********************************/
        this.selectElem.toArray().splice(indice, 1);
        /***************************INFINITE SELECT**********************************/

        // Se vuelven a calcular los descuentos de la venta y los totales
        if(this.venta.AMOUNT_DISCOUNT){
            this.funcionesActivadas = true;
            this.calcularDescuentoVenta(3);
            this.funcionesActivadas = false;
        }
        this.calcularTotalesVenta();
    }


    // ----------------- FUNCIONES CARGOS -----------------
    agregarCargo() {
        if (this.venta.Cargos.length > 0) {
            if (!this.venta.Cargos[this.venta.Cargos.length - 1].COMMENTS && !this.venta.Cargos[this.venta.Cargos.length - 1].TOTAL) {
                return;
            }
        }

        let cargo: DocumentoDetalle = new DocumentoDetalle();
        cargo.identificador = this.identificadorCargos;
        this.venta.Cargos.push(cargo);

        this.agregarNuevoCargoForm(this.identificadorCargos);
        this.identificadorCargos++;

        if (!this.ventaCerrada) {
            setTimeout(() => document.getElementById('cargoItem' + (this.venta.Cargos.length - 1)).focus(), 0);
        }
    }

    cambiarTotalCargo(cargoItem: DocumentoDetalle) {
        if (this.funcionesActivadas) {

            // Se vuelven a calcular los descuentos de la venta y los totales
            if (this.venta.AMOUNT_DISCOUNT) {
                this.calcularDescuentoVenta(3);
            }
            this.calcularTotalesVenta();
        }
    }

    eliminarCargo(indice: number) {
        this.eliminarCargoForm(this.venta.Cargos[indice].identificador);
        this.venta.Cargos.splice(indice, 1);

        // Se vuelven a calcular los descuentos de la venta y los totales
        if(this.venta.AMOUNT_DISCOUNT){
            this.funcionesActivadas = true;
            this.calcularDescuentoVenta(3);
            this.funcionesActivadas = false;
        }
        this.calcularTotalesVenta();
    }


    // ---------------- FUNCIONES CLIENTES ----------------
    clienteChange(opcion: number) {
        for (let i = 0; i < this.listaClientes.length; i++) {
            if(this.listaClientes[i].idCliente == opcion) {
                this.venta.cliente.idCliente = this.listaClientes[i].idCliente;
                this.venta.cliente.razonSocial = this.listaClientes[i].razonSocial;
                this.venta.cliente.DEBT = this.listaClientes[i].DEBT;
                this.venta.cliente.RFC = this.listaClientes[i].rfc;
            }
        }
        this.venta.CUSTOMER_SUPPLIER_ID = opcion;
        this.consultarClienteDirecciones();
        this.consultarClienteSolicita();
        this.consultarListasPrecios();
        this.validarClientePuedeGuardarVenta();
    }


    // ----------- FUNCIONES LISTAS DE PRECIOS ------------
    consultarClienteDirecciones() {
        this.datosGeneralesSAE.showSpinnerLoading = true;
        this._generalService.requestGet("venta/consultarClienteDirecciones?CUSTOMER_ID=" + this.venta.CUSTOMER_SUPPLIER_ID).subscribe(
            (result) => {
                this.listaClienteDirecciones = JSON.parse(result);
                //this.consultarListasPrecios(); Se comenta el 19 de mayo para que lo haga en paralelo y que no este encolado
                let ultimaDireecion = this.listaClienteDirecciones.length - 1;

                if(this.venta.CUSTOMER_ADDRESS_ID != null)
                {

                    if(this.setdireccionEdicion === true){
                        this.venta.CUSTOMER_ADDRESS_ID
                        this.frmVenta.get('ClienteDireccion').setValue(this.venta.CUSTOMER_ADDRESS_ID);
                    }else {
                        this.frmVenta.get('ClienteDireccion').setValue(this.listaClienteDirecciones[ultimaDireecion]['idDireccion']);
                    }

                }
                else if (this.listaClienteDirecciones.length > 0) {
                    const idDireccionTemporal = this.listaClienteDirecciones[this.listaClienteDirecciones.length - 1].idDireccion;
                    this.venta.CUSTOMER_ADDRESS_ID = null;
                    this.frmVenta.get('ClienteDireccion').setValue(idDireccionTemporal);
                    this.venta.CUSTOMER_ADDRESS_ID = idDireccionTemporal;
                }
                else {
                    this.venta.CUSTOMER_ADDRESS_ID = null;
                }
            },
            (error) => {
                const errorMsj =  error as any;
                console.error(errorMsj);
            }
        );
    }

    consultarClienteSolicita() {
        this.datosGeneralesSAE.showSpinnerLoading = true;
        if(this.venta.CUSTOMER_SUPPLIER_ID !== null){

            this._generalService.metodoCallParams(this.venta.CUSTOMER_SUPPLIER_ID, 'Contacto/consultarContactos')
            .subscribe(
                (result) => {
                    try {
                        let listaClienteSolicita;

                        // Verifica si result es una cadena o un objeto
                        if (typeof result === 'string') {
                            listaClienteSolicita = JSON.parse(result);

                        } else {
                            listaClienteSolicita = result;
                            //this.listaClienteSolicita = [];
                            this.listaClienteSolicita = listaClienteSolicita;
                        }


                        const idSolicitaTemporal = this.listaClienteSolicita[this.listaClienteSolicita.length - 1].idContacto;
                        if(this.venta.CUSTOMER_SUPPLIER_CONTACT_ID != null){
                            if(this.setContacto === false){
                                this.frmVenta.get('ClienteSolicita').setValue(idSolicitaTemporal);
                            }else{
                                this.frmVenta.get('ClienteSolicita').setValue(this.venta.CUSTOMER_SUPPLIER_CONTACT_ID);
                            }

                         }else{

                            this.frmVenta.get('ClienteSolicita').setValue(idSolicitaTemporal);
                        }



                    } catch (e) {
                        // console.error('Error parsing JSON:', e);
                    } finally {
                        this.datosGeneralesSAE.showSpinnerLoading = false;
                    }
                },
                (error) => {
                    const errorMsj = error as any;

                    this.datosGeneralesSAE.showSpinnerLoading = false;
                }
            );
        }
    }


    // ----------- FUNCIONES LISTAS DE PRECIOS ------------
    consultarListasPrecios() {
        this.datosGeneralesSAE.showSpinnerLoading = true;
        let params: any = {};
        params.COMPANY_ID = this.userData.COMPANY_ID;

        if(this.venta.DOCUMENT_TYPE_ID){
            params.DOCUMENT_TYPE_ID = this.venta.DOCUMENT_TYPE_ID;
        }
        else{
            params.DOCUMENT_TYPE_ID = null;
        }

        if(this.venta.METHOD_PAYMENT_ID){
            params.METHOD_PAYMENT_ID = this.venta.METHOD_PAYMENT_ID;
        }
        else{
            params.METHOD_PAYMENT_ID = null;
        }

        if(this.venta.CUSTOMER_SUPPLIER_ID){
            params.CUSTOMER_ID = this.venta.CUSTOMER_SUPPLIER_ID;
        }
        else{
            params.CUSTOMER_ID = null;
        }

        var paramsJSON: string = JSON.stringify(params);
        this._generalService.requestGet("venta/consultarListasDePrecios?parametros=" + paramsJSON).subscribe(
            (result) => {
                this.listaListasPrecios = JSON.parse(result);
                for (let i = 0; i < this.venta.Productos.length; i++) {
                    // Se actualiza el precio unitario si aplica en una lista de precio
                    this.aplicarListasPrecios(this.venta.Productos[i]);

                    // Se actualiza el total del producto de venta en base al nuevo precio unitario
                    this.funcionesActivadas = true;
                    this.calcularTotalProducto(this.venta.Productos[i]);
                    this.funcionesActivadas = false;
                }

                this.datosGeneralesSAE.showSpinnerLoading = false;
            },
            (error) => {
                const errorMsj =  error as any;
                console.error(errorMsj);
            }
        );
    }

    aplicarListasPrecios(prod: DocumentoDetalle){
        for(let i = 0; i < this.listaListasPrecios.length; i++){
            // Se verifica que producto de venta aplique en la lista de precio
            if(prod.ITEM_ID === this.listaListasPrecios[i].ITEM_ID){
                // Se verifica que la cantidad del producto de venta aplique en el rango de la lista de precios
                if((Number(prod.QUANTITY) >= this.listaListasPrecios[i].INITIAL_RANGE) && (Number(prod.QUANTITY) <= this.listaListasPrecios[i].FINAL_RANGE)){
                   if(this.banderaC){

                    prod.PRICE = prod.BASE_PURCHASE_PRICE * Number(((Number(this.listaListasPrecios[i].PRICE_FACTOR) / 100)).toFixed(2));
                    prod.PRICE = Number(prod.PRICE.toFixed(2));

                    console.log("Precio base: " + prod.BASE_PURCHASE_PRICE);
                   }else{
                    prod.PRICE = prod.BASE_SALE_PRICE * Number(((Number(this.listaListasPrecios[i].PRICE_FACTOR) / 100)).toFixed(2));
                    prod.PRICE = Number(prod.PRICE.toFixed(2));

                    console.log("Precio base: " + prod.BASE_SALE_PRICE);
                   }

                    console.log("Lista de precio: " + this.listaListasPrecios[i].NAME);
                    console.log("Factor: " + this.listaListasPrecios[i].PRICE_FACTOR);
                    console.log("Precio final: " + prod.PRICE);
                    console.log("---------------------------------------------------------");

                    i = this.listaListasPrecios.length;
                }
            }
            else{
                // Si el producto de la venta no aplica en la lista de precio se verifica que la subfamilia si aplique
                if(prod.ITEM_SUBFAMILY_ID === this.listaListasPrecios[i].ITEM_SUBFAMILY_ID && !this.listaListasPrecios[i].ITEM_ID){
                    // Se verifica que la cantidad del producto de venta aplique en el rango de la lista de precios
                    if((Number(prod.QUANTITY) >= this.listaListasPrecios[i].INITIAL_RANGE) && (Number(prod.QUANTITY) <= this.listaListasPrecios[i].FINAL_RANGE)){
                        prod.PRICE = prod.BASE_SALE_PRICE * Number(((Number(this.listaListasPrecios[i].PRICE_FACTOR) / 100)).toFixed(2));
                        prod.PRICE = Number(prod.PRICE.toFixed(2));
                        i = this.listaListasPrecios.length;
                    }
                }
                else{
                    // Si el producto ni la subfamilia de la venta aplican en la lista de precio se verifica que la familia si aplique
                    if(prod.ITEM_FAMILY_ID === this.listaListasPrecios[i].ITEM_FAMILY_ID && !this.listaListasPrecios[i].ITEM_SUBFAMILY_ID && !this.listaListasPrecios[i].ITEM_ID){
                        // Se verifica que la cantidad del producto de venta aplique en el rango de la lista de precios
                        if((Number(prod.QUANTITY) >= this.listaListasPrecios[i].INITIAL_RANGE) && (Number(prod.QUANTITY) <= this.listaListasPrecios[i].FINAL_RANGE)){
                            prod.PRICE = prod.BASE_SALE_PRICE * Number(((Number(this.listaListasPrecios[i].PRICE_FACTOR) / 100)).toFixed(2));
                            prod.PRICE = Number(prod.PRICE.toFixed(2));
                            i = this.listaListasPrecios.length;
                        }
                    }
                    else{
                        // Si ni el producto, subfamilia ni familia aplican en la lista de precio se verifica que la lista de precio aplique para todas las familias, subfamilias y productos
                        if(!this.listaListasPrecios[i].ITEM_ID && !this.listaListasPrecios[i].ITEM_SUBFAMILY_ID && !this.listaListasPrecios[i].ITEM_FAMILY_ID){
                            // Se verifica que la cantidad del producto de venta aplique en el rango de la lista de precios
                            if((Number(prod.QUANTITY) >= this.listaListasPrecios[i].INITIAL_RANGE) && (Number(prod.QUANTITY) <= this.listaListasPrecios[i].FINAL_RANGE)){
                                prod.PRICE = prod.BASE_SALE_PRICE * Number(((Number(this.listaListasPrecios[i].PRICE_FACTOR) / 100)).toFixed(2));
                                prod.PRICE = Number(prod.PRICE.toFixed(2));
                                i = this.listaListasPrecios.length;
                            }
                        }
                    }
                }
            }
        }
    }


    // -------------- FUNCIONES SECUNDARIAS ---------------
    activarFunciones(){

        this.funcionesActivadas = true;
    }

    desactivarFunciones(){

        this.funcionesActivadas = false;
    }

    modal(tipo: string, mensaje: string) {
        this.dataService.modal = tipo;
        this.dataService.mensaje = mensaje;
        const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
        this.dataService.dialogModal = dialogModal;
    }

    hasDecimalPlace(value: any, decimales: any) {
        // Verifica que solo cuente con las decimales que se establecio en el input
        const ed = value.split(".");
        if(ed.length > 1){
            return ed[1].length > 2;
        }
        else{
            return false;
        }
    }

    inputNumerosConDecimales(e: any, valor: any, decimales: number): boolean {
        // Verifica que la tecla ingresada fuera copiar, pegar, eliminar, numeros o puntos decimales
        if ([8, 9, 13, 27, 46, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) ||
            (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) ||
            (e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) ||
            (e.keyCode === 88 && e.ctrlKey === true)) {

            const character = String.fromCharCode(e.keyCode);
            valor = (valor) ? valor : '';
            const newValue: any = valor + character;
            // Verifica que no tenga más de un punto y que solo cuente con las decimales que se establecio en el input
            if (isNaN(newValue) || this.hasDecimalPlace(newValue, decimales)) {
                e.preventDefault();
                return false;
            }
            else{
                return;
            }
        }
        else{
            e.preventDefault();
            return false;
        }
    }

    inputNumerosEnteros(event: any, valor: any) {
        const e = event as KeyboardEvent;

        // Verifica que la tecla ingresada fuera copiar, pegar, eliminar o numeros 
        if ([8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) ||
            (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) ||
            (e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) ||
            (e.keyCode === 88 && e.ctrlKey === true)) {
            return;
        }
        else{
            e.preventDefault();
            return false;
        }
    }

    onPaste(e: any) {

        e.preventDefault();
    }

    scrollPage() {
        $('#scrollCaja').css({
            top: ($(window).scrollTop()) + 'px'
        });
    }

    compararClientes(clienteA: Cliente, clienteB: Cliente) {
       // return clienteA && clienteB && clienteA.idCliente === clienteB.idCliente;
        return  clienteA.idCliente === clienteB.idCliente;
    }

    /***************************INFINITE SELECT**********************************/
    registerPanelScrollEvent(el) {
        const panel = el.panel.nativeElement;
        panel.addEventListener('scroll', event => this.loadAllOnScroll(event, el.id));
    }

    loadAllOnScroll(event, id: string) {
        const idProd = parseInt(id.replace('productoItem', ''));
        if ((event.target.scrollTop+1) >= (event.target.scrollHeight - event.target.offsetHeight)) {
            if(this.venta.Productos[idProd].isFilteredProd) {
                if (this.venta.Productos[idProd].filteredItemsShow < this.venta.Productos[idProd].arrayFilteredProd.length) {
                    this.venta.Productos[idProd].filteredItemsShow += 10;
                    this.venta.Productos[idProd].lstProductoFiltradas = this.venta.Productos[idProd].arrayFilteredProd.slice(0, this.venta.Productos[idProd].filteredItemsShow);
                    this.ref.detectChanges();
                }
            } else {
                if (this.venta.Productos[idProd].itemsShow < this.venta.Productos[idProd].lstProducto.length) {
                    this.venta.Productos[idProd].itemsShow += 10;
                    this.venta.Productos[idProd].lstProductoFiltradas = this.venta.Productos[idProd].lstProducto.slice(0, this.venta.Productos[idProd].itemsShow);
                    this.ref.detectChanges();
                }
            }
        }
    }

    registerPanelScrollEventUnico() {
        const panel = this.selectElemUnico.panel.nativeElement;
        panel.addEventListener('scroll', event => this.loadAllOnScrollUnico(event));
    }

    loadAllOnScrollUnico(event) {
        if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
            if(this.isFilteredCli) {
                if(this.filteredCliItemsShow < this.arrayFilteredCli.length) {
                    this.filteredCliItemsShow += 10;
                    this.viewDataClientes = this.arrayFilteredCli.slice(0, this.filteredCliItemsShow);
                    this.ref.detectChanges();
                }
            } else {
                if(this.itemsShow < this.listaClientes.length) {
                      this.itemsShow += 10;
                      this.viewDataClientes = this.listaClientes.slice(0, this.itemsShow);
                      this.ref.detectChanges();
                }
            }
        }
      }
    /***************************INFINITE SELECT**********************************/

    async mostrarModalAgregarProducto(productId) {
        const productoSeleccionado = await this.consultarProducto(productId);
        const modalAgregarProducto = this.dialog.open(ProductAddEditComponent, {
            height: '80%',
            data: {producto: productoSeleccionado},
         });

        modalAgregarProducto.afterClosed().subscribe((producto) => {
            if (producto) {
                this.agregarProductoListaProductos(producto);
            }
        });
    }

    async mostrarModalDireccion(esEdicion) {
        let mensajeExito = '';
        this.dataService.idCliente = this.venta.cliente.idCliente;

        if (esEdicion) {
            this.dataService.tipo = "editar";
            this.dataService.id = this.venta.CUSTOMER_ADDRESS_ID;
            mensajeExito = 'La Dirección se modificó exitosamente';

        } else {
            this.dataService.tipo = "agregar";
            mensajeExito = 'La Dirección se agregó exitosamente';

        }

        const dialogRef = this.dialog.open(direccionAddEditComponent, {disableClose: true, width:'100%', maxWidth:'60%', panelClass: 'full-width-dialog',data: { 
            vistaBtn: this.vistaBtn
          }});
        this.dataService.dialogRef = dialogRef;
        dialogRef.afterClosed().subscribe((result) => {
          if(this.dataService.guardado){
            this._generalService.toastCall(mensajeExito);
            this.setdireccionEdicion =false;
            this.consultarClienteDirecciones();
            this.consultarListasPrecios();
          } else if(this.dataService.mensajeAlert != "" && this.dataService.mensajeAlert != undefined){
            this._generalService.toastCall(this.dataService.mensajeAlert);
          }
          
        });
    }

    async mostrarModalCliente() {
        const self = this;
        let tipoVentaOpcion = this.frmVenta.get('TipoVenta')?.value;
        this.parametroUrl == ':parametro' ? this.aux =1 : this.aux =2;
        const dialogRef = this.dialog.open(ClienteSaeAgregarEditarComponent, {
            height: '75%',
            panelClass: 'full-width-dialog',
            data: {
                esModal: true,
                agregar:this.aux,
            }
        });

        dialogRef.afterClosed().subscribe((result) => {
            console.log("this en el subscribe:", this);  // Asegúrate de que este 'this' sea el correcto

            if (self.dataService.guardado) {
                self.clienteAlta = true;
                let number = +result
                self.idClienteAlta = number;
                this.consultarClientes(() => {
                    // if(tipoVentaOpcion != null){

                    // }else{

                    // }
                    this.cargarPantalla(true, tipoVentaOpcion);
                    self.dataService.guardado = false;
                    // this.frmVenta.get('TipoVenta')?.setValue(tipoVentaOpcion);
                });

            }
        });
    }
    

    agregarProductoListaProductos(productoNuevo: Item) {
        this.venta.Productos.forEach(producto => {
            const _producto = {
                BARCODE: productoNuevo.barcode,
                BASE_PURCHASE_PRICE: productoNuevo.basePurchasePrice,
                BASE_SALE_PRICE: productoNuevo.baseSalePrice,
                COMPANY_ID: productoNuevo.companyId,
                CONTAINER_ID: productoNuevo.containerId,
                CONTAINS_TAX: productoNuevo.containsTax,
                ITEM_ID: productoNuevo.itemId,
                ITEM_SUBFAMILY_ID: productoNuevo.itemSubfamilyId,
                LONG_DESCRIPTION: productoNuevo.longDescription,
                MINIMUM_UNIT_ID: productoNuevo.minimumUnitId,
                NAME: `${productoNuevo.SKU} ${productoNuevo.name}`,
                SHORT_DESCRIPTION: productoNuevo.shortDescription,
                STATUS: productoNuevo.status,
                UNITS_PER_CONTAINER: productoNuevo.unitsPerContainer
            }

            if (producto.lstProductoFiltradas.length == producto.lstProducto.length) {
                producto.lstProductoFiltradas.push(_producto);
            }
            producto.lstProducto.push(_producto);
        });
    }

    consultarProducto(productId: number): Promise<any> {
        return new Promise((resolve, reject) =>  {
            this._generalService.metodoCall(`item/consultItem?itemId=${productId}`, true)
                .subscribe(item => {
                    item = JSON.parse(item);
                    if (item.length > 0) {
                        resolve(item[0]);
                    }
                    resolve(null);
                }, error => {
                    resolve(null);
                  // Custom error handler
                });
        });
      }

    selectClient()  {
        const self = this
        if (self.clienteAlta) {
            let index = self.listaClientes.findIndex( e => e.idCliente === self.idClienteAlta);
            var a = self.listaClientes.splice(index,1);
            self.listaClientes.unshift(a[0]);
            self.venta.cliente.idCliente = self.idClienteAlta;
            self.frmVenta.get('Cliente').setValue(self.idClienteAlta);
            self.clienteChange(self.idClienteAlta);
        }
    }
    consultarClientes(onComplete?: () => void) {
        const self = this
        const loacs = sessionStorage.getItem('acslo');
        this._generalService.metodoCallParams(loacs, 'clienteSAE/consultarClientesOrdenAlfabetico', true)
            .subscribe((clientes) => {
                self.listaClientes = clientes;
                self.selectClient()
                /*
                if (self.clienteAlta) {
                    let index = self.listaClientes.findIndex( e => e.idCliente === self.idClienteAlta);
                    var a = self.listaClientes.splice(index,1);
                    self.listaClientes.unshift(a[0]);
                    self.venta.cliente.idCliente = self.idClienteAlta;
                    self.frmVenta.get('Cliente').setValue(self.idClienteAlta);
                    self.clienteChange(self.idClienteAlta);
                }
                */
                self.viewDataClientes = self.listaClientes.slice(0, 10);
                console.log("viewDataClientes", self.viewDataClientes)
                if (onComplete) {
                    onComplete();
                }
            }, (error) => {
            console.log(error);
                self._generalService.toastCall(error);
                if (onComplete) {
                    onComplete();
                }
            }
        );
    }

    validarClientePuedeGuardarVenta() {
        // if (this.venta.cliente.DEBT < 0) {
            // this.bloquearBtnGuardar = true;
        // } else {
            //Fix: 2023/07/04: Corrección para que deje guardar ventas aún y que el cliente cuente con saldo a favor
            this.bloquearBtnGuardar = false;
        // };
    }


    //NUEVAS FUNCIONES
    permitirDecimales(producto: DocumentoDetalle) {
        let webService = 'venta/permitirDecimales?idItem=' + producto.ITEM_ID;
        this._generalService
          .metodoCall(webService, true)
          .subscribe(result => {
            let newArray = result;
            producto.piezasContenedor = newArray[0].piezasContenedor;
            producto.allowDecimals = newArray[0].allowDecimals;
            },
          error => {  console.log(<any>error);  }
        );
      }

    getIva() {
        let webService = 'venta/getIva';
        this._generalService
          .metodoCall(webService, true)
          .subscribe(result => {
            let newArray = result;
            this.IVAPercent = newArray[0].MEANING;
            this.calcularTotalesVenta();
            },
          error => {  console.log(<any>error);  }
        );
      }

    consultaPagosxVenta(idVenta) {
    let webService = 'venta/consultaPagosxVenta?idVenta=' + idVenta
    this._generalService.metodoCall(webService, true)
        .subscribe(result => {
            if(result[0].existeDeuda){
                this.existeDeuda = true;
            } else {
                this.existeDeuda = false;
            }
        },
        error => {  console.log(<any>error);  }
    );
    }

    /*mostrarModalSalida() {
    const dialogRef = this.dialog.open(ModalSalidaVentaComponent, { disableClose: true });

        dialogRef.afterClosed().subscribe((crearSalida) => {
            if (crearSalida) {
                //Aqui va lo que se haría si acepta crear la salida


            } else {
                //Aqui va lo que se haría si no se crea la salida


            }
        });
    }*/

    validarNombre(){

        if( this.parametroUrl == ':parametro')
        {
            this.titulo = 'Nueva Compra';
            this.bandera = false;
            this.banderaC = true;
            this.tituloFecha='Fecha de Compra*'
        }
        else
        {                this.titulo = 'Nueva Venta';
            this.bandera = true;
            this.banderaC = false;
            this.tituloFecha='Fecha de Venta*'
            this.VENTA_DESC_PCOMPRA_bandera_Pantalla = true;
        }
    }
    addSolicitante(){
        this.dataService.idCliente = this.venta.CUSTOMER_SUPPLIER_ID;
        const dialogRef = this.dialog.open(contactoAddEditComponent,
        {disableClose: true, width:'100%', maxWidth:'60%', panelClass: 'full-width-dialog'});
        this.dataService.dialogRef = dialogRef;
        dialogRef.afterClosed().subscribe((result) => {
            if(this.dataService.guardado){
                this.consultarClienteSolicita();
                this.setContacto = false;
                this._generalService.toastCall("El contacto se agregó exitosamente!");

            }
      });
    }

    // --------------- FUNCION DE CARGA -------------------

    organizationDiscount() {
        let idSucursal:number = this.userData.ORGANIZATION_ID;
        let webService = 'venta/organizationDiscountVenta?idSucursal=' + idSucursal;
        this._generalService
          .metodoCall(webService, true)
          .subscribe(result => {
            let newArray = result;
            this.VENTA_DESC_PCOMPRA = newArray[0].VENTA_DESC_PCOMPRA;

            if(this.VENTA_DESC_PCOMPRA == '1'){
                this.VENTA_DESC_PCOMPRA_bandera = true;
            }

            },
          error => {  console.log(<any>error);  }
        );
    }

    getDataFilters() {
    
        let metodo = 'clienteSAE/validarCamposCartaPorte';
        const params = { 
            loacs: this.loacs
        };
    
        this._generalService.metodoCallParams(this.loacs, metodo).subscribe(
          result => {
            const tableResult = JSON.parse(result);
            //console.log(tableResult)
            if(tableResult[0].VALUE == '1'){
              this.vistaBtn = true;
            }else{
              this.vistaBtn = false;
            }
          },
          error => {  console.log(<any>error);  }
        );
      }
      

}



// WEBPACK FOOTER //
// ./src/app/venta/agregar/venta-agregar.component.ts